import { ConnectButton } from "@rainbow-me/rainbowkit";
import { doc, getDoc, setDoc } from "firebase/firestore";
import React, { useEffect, useState } from "react";
import { useAccount, useWalletClient } from "wagmi";
import { toast } from "react-toastify";
import {
  auth,
  firestoredb,
  getmapdata,
  uploadImgPlot,
} from "../../../firebase/firebase";
import {
  RentOffer,
  getBuyRentNfts,
  getMyNFTss,
  approveLandListing,
  checkApproval,
  listLand,
} from "../../contractInteraction/contractInteraction";
import { onAuthStateChanged } from "firebase/auth";
import Modal from "react-bootstrap/Modal";
import "./Inventory.css";
import { Icon } from "@iconify/react";
function Inventory() {
  const { address } = useAccount();
  const { data: signer } = useWalletClient();
  const [mynfts, setMynfts] = useState([]);
  const [mynfts2, setMynfts2] = useState([]);
  const [show, setShow] = useState(false);
  const [updateShow, setUpdateShow] = useState(false);
  const [approveShow, setApproveShow] = useState(false);
  const [listShow, setListShow] = useState(false);
  const [month, setMonth] = useState("");
  const [price, setPrice] = useState("");
  const [listPrice, setListPrice] = useState("");
  const [newName, setNewName] = useState("");
  const [newDescription, setNewDescription] = useState("");
  const [newImage, setNewImage] = useState("");
  const [newUploadImage, setNewUploadImage] = useState("");
  const [currentTokenid, setCurrentTokenid] = useState("");
  const [mapNumber, setMapNumber] = useState();
  // const [mapNumber, setMapNumber] = useState();
  const [coordinate, setCordinate] = useState();
  const [userisLogged, setUserisLogged] = useState();
  const [approvalCheck, setApprovalCheck] = useState();

  const handleClose = () => setShow(false);
  const updateHandleClose = () => setUpdateShow(false);
  const approveHandleClose = () => setApproveShow(false);
  const listHandleClose = () => setListShow(false);

  const getMyPlot = async () => {
    setMynfts([]);
    setMynfts2([]);
    if (address) {
      // var mylist=[]

      await getMyNFTss(address)
        .then((res) => {
          console.log("getMyNfts called");
          console.log(res[0]);
          console.log(res[1]);

          res[0].map(async (item, index) => {
            await checkApproval(item.tokenId).then((res) =>
              setApprovalCheck((prev) => ({ ...prev, [item.tokenId]: res }))
            );
          });

          // let rentedCoordinate = [];
          res[0].map(async (item, index) => {
            const mapnumber = item.coordinate.split("-");

            console.log(mapnumber[0]);
            let listingApproved;
            let landListed;
            // console.log("Sequence Start", item.tokenId)
            // if (item.listed){
            //   console.log("Approval Check");
            //   listingApproved = await checkApproval(item.tokenId);
            //   landListed = false;
            //   console.log("Item Listed", item.listed)
            //   console.log("Approval Check End", listingApproved);
            // }
            // else{
            //   listingApproved = true;
            //   landListed = true;
            // }
            console.log("Sequence End", item.tokenId);
            const docRef = doc(firestoredb, "map", mapnumber[0]);
            await getDoc(docRef)
              .then((res) => {
                // mylist.push(res.data()[item.coordinate])
                setMynfts((prev) => [
                  ...prev,
                  {
                    data: res.data()[item.coordinate],
                    coordinate: item.coordinate,
                    tokenId: item.tokenId,
                    mapNumber: mapnumber,
                    landListed: item.listed,
                  },
                ]);
                console.log(
                  "brooooooo",
                  res.data()[item.coordinate]?.listRented
                );
              })
              .catch((err) => {
                console.log(err);
              });
          });
          console.log(res[1]);
          // console.log("dfd", rentedCoordinate)
          res[1].map(async (item, index) => {
            if (item.isActive) {
              const mapnumber = item.coordinate.split("-");
              console.log(mapnumber.length > 0);
              const docRef = doc(firestoredb, "map", mapnumber[0]);
              await getDoc(docRef)
                .then((res) => {
                  // mylist.push(res.data()[item.coordinate])
                  // setMynfts2(prev => [...prev, { data: res.data()[item.coordinate], coordinate: item.coordinate }])
                  // setMynfts2(prev => [...prev, { data: res.data()[rentedCoordinate[index]], coordinate: rentedCoordinate[index] }])
                })
                .catch((err) => {
                  console.log(err);
                });
            }
          });
        }).catch(err => {
          console.log(err);
        })
      await getBuyRentNfts(address).then(res => {
        console.log("Buyers lengh", res)
        res.map(async (item, index) => {

          // const mapnumber = item.coordinate.split("-")
          const mapnumber = item.coordinate.split("-");
          console.log(mapnumber.length > 0);
          const docRef = doc(firestoredb, "map", mapnumber[0]);
          await getDoc(docRef).then(res => {
            // mylist.push(res.data()[item.coordinate])
            // setMynfts2(prev => [...prev, { data: res.data()[item.coordinate], coordinate: item.coordinate }])
            setMynfts2(prev => [...prev, { data: res.data()[item.coordinate], coordinate: item.coordinate, tokenId: item.tokenId, mapNumber: mapnumber }])
          }).catch(err => {
            console.log(err);
          })
        })
      })
        .catch((err) => {
          console.log(err);
        });
    }
  };
  const rentNowModal = (tokenid, mapNumber, coordinate) => {
    console.log("rent", tokenid);
    setMapNumber(mapNumber);
    setCordinate(coordinate);
    setCurrentTokenid(tokenid);
    setShow(true);
  };

  const approveNowModal = (tokenid, mapNumber, coordinate) => {
    console.log("rent", tokenid);
    setMapNumber(mapNumber);
    setCordinate(coordinate);
    setCurrentTokenid(tokenid);
    setApproveShow(true);
  };

  const listNowModal = (tokenid, mapNumber, coordinate) => {
    console.log("rent", tokenid);
    setMapNumber(mapNumber);
    setCordinate(coordinate);
    setCurrentTokenid(tokenid);
    setListShow(true);
  };

  const updateNowModal = (tokenid, mapNumber, coordinate, newImage) => {
    console.log("Update", tokenid);
    setMapNumber(mapNumber);
    setCordinate(coordinate);
    setNewImage(newImage);
    setCurrentTokenid(tokenid);
    setUpdateShow(true);
  };

  useEffect(() => {
    const unsubscribe = onAuthStateChanged(auth, (user) => {
      if (user) {
        const { uid } = user;
        setUserisLogged(user);
      } else {
        setUserisLogged(user);
      }
    });
    return () => unsubscribe();
  }, []);

  useEffect(() => {
    console.log("In Use Effect");
    console.log(mapNumber);
    console.log(coordinate);
  }, [mapNumber, coordinate]);

  useEffect(() => {
    console.log("for test");
    console.log(approvalCheck);
  }, [approvalCheck]);

  const rentNow = async () => {
    console.log("month", month);
    console.log("price", price);
    console.log("currentTokenid", currentTokenid);
    console.log("currentTokenid", address);
    console.log("currentTokenid", address);
    console.log("currentTokenid", signer);
    console.log("Coordinate", coordinate);

    RentOffer(address, currentTokenid, month, price, coordinate, signer)
      .then(async (res) => {
        console.log(res);
        if (res.success) {
          if (userisLogged) {
            await setDoc(
              doc(firestoredb, "map", mapNumber[0]),
              {
                [coordinate]: {
                  listRented: true,
                  boughtRented: false,
                  rentPrice: price,
                },
              },
              { merge: true }
            )
              .then((res) => console.log(res))
              .catch((err) => {
                console.log(err);
              });
          } else {
            toast("Please login");
          }
        }
      })
      .catch((err) => {
        console.log(err);
      });
  };

  const updateData = async () => {
    console.log("month", month);
    console.log("price", price);
    console.log("currentTokenid", currentTokenid);
    console.log("currentTokenid", address);
    console.log("currentTokenid", address);
    console.log("currentTokenid", signer);

    if (userisLogged) {
      if (newUploadImage) {
        await uploadImgPlot(newUploadImage, userisLogged)
          .then(async (res) => {
            console.log(res);
            // setDownloadUrl(res)
            await setDoc(
              doc(firestoredb, "map", mapNumber[0]),
              {
                [coordinate]: {
                  name: newName,
                  description: newDescription,
                  background: `url(${res})`,
                },
              },
              { merge: true }
            ).then(res => {
              console.log(res)
              toast("Data Updated Successfully");
              getMyPlot()
            })
              .catch((err) => {
                console.log(err);
              });
          })
          .catch((err) => {
            console.log(err);
          });
      }
      else {

        await setDoc(
          doc(firestoredb, "map", mapNumber[0]),
          {
            [coordinate]: {
              name: newName,
              description: newDescription,
            },
          },
          { merge: true }
        ).then(res => {
          console.log(res)
          toast("Data Updated Successfully");
          getMyPlot()
        })
          .catch((err) => {
            console.log(err);
          });
      }

    } else {
      toast("Please login");
    }
  };

  const approveLandSelling = async () => {
    await approveLandListing(currentTokenid, signer)
      .then(async (res) => {
        console.log(res);
        if (res.success) {
          if (userisLogged) {
            await setDoc(
              doc(firestoredb, "map", mapNumber[0]),
              {
                [coordinate]: {
                  approvedListing: true,
                },
              },
              { merge: true }
            )
              .then((res) => console.log(res))
              .catch((err) => {
                console.log(err);
              });
          } else {
            toast("Please login");
          }
        }
      })
      .catch((err) => {
        console.log(err);
      });
  };

  //Land Listing
  const listNow = async () => {
    console.log("List now month", month);
    console.log("List Price", listPrice);
    console.log("currentTokenid", currentTokenid);
    console.log("currentTokenid", address);
    console.log("currentTokenid", address);
    console.log("currentTokenid", signer);
    console.log("Coordinate", coordinate);

    listLand(Number(listPrice), currentTokenid, signer)
      .then(async (res) => {
        console.log(res);
        if (res.success) {
          if (userisLogged) {
            await setDoc(
              doc(firestoredb, "map", mapNumber[0]),
              {
                [coordinate]: {
                  listSell: true,
                  listPrice: Number(listPrice),
                },
              },
              { merge: true }
            )
              .then((res) => console.log(res))
              .catch((err) => {
                console.log(err);
              });
          } else {
            toast("Please login");
          }
        }
      })
      .catch((err) => {
        console.log(err);
      });
  };

  useEffect(() => {
    getMyPlot();
  }, [address]);

  useEffect(() => {
    console.log("In use Effect line 191, INventory");
    console.log(mynfts);
  }, [mynfts]);

  useEffect(() => {
    console.log("In use Effect line 196, INventory");
    console.log(mynfts2);
  }, [mynfts2]);

  return (
    <div>
      <div className="inventory">
        <div className="inventory-content">
          <h1>my Lands</h1>
          <div className="card-abba">
            {address ? (
              mynfts.length > 0 ?
                mynfts.map((item, index) => {
                  const imageHtml = item.data.background.split("(");
                  return (
                    <div className="card" key={index}>
                      <div className="card-header">
                        <img src={imageHtml[1]} alt="" className="img-fluid" />
                      </div>
                      <div className="card-body">
                        <div className="name">
                          <h1>{item.data.name}</h1>
                          <p className="para d-flex ">
                            <img
                              src="\assets\images\Account-setting\locationIcon.svg"
                              alt="land"
                              className="1mg-100"
                            />
                            <span className="text-light-green mx-2">
                              {item.coordinate}
                            </span>
                          </p>
                        </div>
                        <div className="location mt-3">
                          <p className="para ">Size: {item.data.size}</p>
                          <p className="para ">
                            <span className="text-light-green">
                              {item.data?.listRented ? "Already Listed on Rent" : "Available to rent"}
                            </span>
                          </p>
                        </div>
                        <div className="button-wrapper d-flex g-10">
                          <button disabled={item.data?.listRented || item.data?.boughtRented} style={item.data?.listRented || item.data?.boughtRented ? { cursor: "not-allowed" } : {}} onClick={() => rentNowModal(item.tokenId, item.mapNumber, item.coordinate)}>Rent</button>
                          {!(item.landListed) ?
                            <button disabled={!(item.landListed)} style={!(item.landListed) ? { cursor: "not-allowed" } : {}} onClick={() => listNowModal(item.tokenId, item.mapNumber, item.coordinate)}>List</button>
                            :
                            approvalCheck &&
                              approvalCheck[item.tokenId] ?
                              <button onClick={() => listNowModal(item.tokenId, item.mapNumber, item.coordinate)}>List</button>
                              :

                              <button onClick={() => approveNowModal(item.tokenId, item.mapNumber, item.coordinate)}>Approve</button>}

                          <button disabled={item.data?.boughtRented} style={item.data?.boughtRented ? { cursor: "not-allowed" } : {}} onClick={() => updateNowModal(item.tokenId, item.mapNumber, item.coordinate, imageHtml[1])}>Update</button>
                        </div>
                      </div>
                    </div>
                  );
                }) : <span style={{ color: "white" }}>You havn't purchased any Land</span>
            ) : (
              <ConnectButton />
            )}
          </div>
        </div>
        <div className="inventory-content mt-5">
          <h1>Rented NFTs</h1>
          <div className="card-abba">
            {address ? (
              mynfts2.length > 0 ?
                mynfts2.map((item, index) => {
                  const imageHtml = item.data.background.split("(");
                  return (
                    <div className="card" key={index}>
                      <div className="card-header">
                        <img src={imageHtml[1]} alt="" className="img-fluid" />
                      </div>
                      <div className="card-body">
                        <div className="name">
                          <h1>{item.data.name}</h1>
                          <p className="para d-flex ">
                            <img
                              src="\assets\images\Account-setting\locationIcon.svg"
                              alt="land"
                              className="1mg-100"
                            />
                            <span className="text-light-green mx-2">
                              {item.coordinate}
                            </span>
                          </p>
                        </div>
                        <div className="location mt-3">
                          <p className="para ">Size: {item.data.size}</p>
                          <p className="para ">
                            <span className="text-light-green">
                              Bought on Rent
                              Bought on Rent
                            </span>
                          </p>
                        </div>
                        <div className="button-wrapper d-flex g-10">
                          {/* <button onClick={rentNowModal}>Rent</button>
                        {/* <button onClick={rentNowModal}>Rent</button>
                      <button>List</button> */}
                          <button onClick={() => updateNowModal(item.tokenId, item.mapNumber, item.coordinate, imageHtml[1])}>Update</button>
                        </div>
                      </div>
                    </div>
                  );
                }) : <span style={{ color: "white" }}>You havn't purchased any Rented Land</span>
            ) : (
              <ConnectButton />
            )}
          </div>
        </div>
      </div>

      <Modal show={show} onHide={handleClose} centered className="new-modal">
        <Modal.Header>
          <Modal.Title>Modal heading</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div className="input-box">
            <input
              type="email"
              name=""
              placeholder="Enter Month"
              id=""
              onChange={(e) => setMonth(e.target.value)}
              className="input-1"
            />
            <input
              type="email"
              name=""
              placeholder="Enter Price"
              id=""
              onChange={(e) => setPrice(e.target.value)}
            />
          </div>
        </Modal.Body>
        <Modal.Footer>
          <button className="one-btn" variant="secondary" onClick={handleClose}>
            Close
          </button>
          <button className="two-btn" variant="primary" onClick={rentNow}>
            Rent
          </button>
        </Modal.Footer>
      </Modal>

      <Modal
        show={updateShow}
        onHide={updateHandleClose}
        centered
        className="new-modal"
      >
        <Modal.Header>
          <Modal.Title>Modal heading</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div className="input-box">
            <div className="updateImage">
              <label htmlFor="newImage">
                <img src={newImage}></img>
              </label>
              <span className="choseImageText">Choose Image</span>
              <input
                id="newImage"
                style={{ display: "none" }}
                type="file"
                onChange={(e) => {
                  setNewImage(URL.createObjectURL(e.target.files[0]));
                  setNewUploadImage(e.target.files[0]);
                }}
              ></input>
            </div>

            <input
              type="text"
              name=""
              placeholder="New Name"
              id=""
              onChange={(e) => setNewName(e.target.value)}
            />
            <input
              type="text"
              name=""
              placeholder="New Description"
              id=""
              onChange={(e) => setNewDescription(e.target.value)}
            />
          </div>
        </Modal.Body>
        <Modal.Footer>
          <button
            className="one-btn"
            variant="secondary"
            onClick={updateHandleClose}
          >
            Close
          </button>
          <button className="two-btn" variant="primary" onClick={updateData}>
            Update
          </button>
        </Modal.Footer>
      </Modal>
      {/* Model for approve button in inventery section */}
      <Modal
        show={approveShow}
        onHide={approveHandleClose}
        centered
        className="new-modal"
      >
        <Modal.Header>
          <Modal.Title>Modal heading</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div className="input-box">
            <h1 className="text-white">
              Are you sure you want to approve this Land for Selling?
            </h1>
          </div>
        </Modal.Body>
        <Modal.Footer>
          <button
            className="one-btn"
            variant="secondary"
            onClick={approveHandleClose}
          >
            Close
          </button>
          <button
            className="two-btn"
            variant="primary"
            onClick={approveLandSelling}
          >
            Approve
          </button>
        </Modal.Footer>
      </Modal>

      <Modal
        show={listShow}
        onHide={listHandleClose}
        centered
        className="new-modal"
      >
        <Modal.Header>
          <Modal.Title>Modal heading</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div className="input-box">
            <input
              type="email"
              name=""
              placeholder="Price"
              id=""
              onChange={(e) => setListPrice(e.target.value)}
            />
          </div>
        </Modal.Body>
        <Modal.Footer>
          <button
            className="one-btn"
            variant="secondary"
            onClick={listHandleClose}
          >
            Close
          </button>
          <button className="two-btn" variant="primary" onClick={listNow}>
            List
          </button>
        </Modal.Footer>
      </Modal>
    </div>
  );
}


export default Inventory;
